import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

// Hämta planerad kalender för en maskin och intervall
export function useMachineCalendar(machineId, fromDate, toDate) {
    return useQuery({
        queryKey: ["machineCalendar", machineId, fromDate, toDate],
        enabled: !!machineId && !!fromDate && !!toDate,
        queryFn: async () => {
            // Matchar: [HttpGet("machine/{machineId:int}")]
            // public Task GetMachineCalendar(int machineId, DateTime from, DateTime to)
            const res = await axios.get(`/api/productioncalendar/machine/${machineId}`, {
                params: {
                    from: fromDate,
                    to: toDate,
                },
            });
            return res.data; // List<MachineDayPlanViewModel>
        },
        staleTime: 60000,
    });
}

// Trigga generering av kalender (backend: GenerateCalendarForMachineAsync)
export function useGenerateMachineCalendar() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            // payload: { machineId, fromDate, toDate }
            await axios.post("/api/productioncalendar/generate", payload);
        },
        onSuccess: (_data, variables) => {
            const { machineId, fromDate, toDate } = variables;
            if (machineId && fromDate && toDate) {
                queryClient.invalidateQueries([
                    "machineCalendar",
                    machineId,
                    fromDate,
                    toDate,
                ]);
            }
        },
    });
}

export function useOverrideDay() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            await axios.post("/api/productioncalendar/override", payload);
        },
        onSuccess: (payload) => {
            const { machineId, date } = payload || {};

            if (machineId && date) {
                queryClient.invalidateQueries([
                    "machineCalendar",
                    machineId,
                    date,
                    date
                ]);
            }
        },
    });
}

export function useClearOverrideDay() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (payload) => {
            await axios.delete("/api/productioncalendar/override", { data: payload });
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ["calendarMatrix"], exact: false });
        },
    });
    
}

export function useCalendarOverview(companyKey, fromDate, toDate, machineId) {
    return useQuery(
        ["calendarOverview", companyKey, fromDate, toDate, machineId],
        async () => {
            const params = {
                companyKey,
                fromDate,
                toDate,
            };

            if (machineId) {
                params.machineId = machineId;
            }

            const response = await axios.get("/api/productioncalendar/overview", {
                params,
            });

            return response.data;
        },
        {
            enabled: !!companyKey && !!fromDate && !!toDate,
            staleTime: 60_000,
        }
    );
}
